<template>
  <div id="price">
    <div class="price1">
        <img :src="url+banner.images" alt=""  @click="jumpbannerpage(banner.url)">
        <ul class="price1Box">
            <li v-for="(item,index) in price1" :key="index" class="price1Boxlist">
                <div class="top"> 
                    <img src="@/assets/price/tip.png" alt="" v-if="index==2" class="tip">
                    <p class="p1">{{item.title}}</p>
                    <img src="@/assets/price/baise11.png" alt="">
                </div>
                <div class="bottom">
                    <p class="p2" v-html="item.content"></p>
                    <ul>
                        <li class="li1">￥<span>{{item.price}}</span></li>
                        <li class="li2">￥<span>{{item.originalprice}}</span></li>
                        <li class="li3">
                            <button @click="submit(false,url+item.image)">立即购买</button>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
    <div class="price2">
        <div class="price2top">
            <p class="title">活码功能</p>
            <ul v-show="price2.length<4">
                <li v-for="(item,index) in price2" :key="index"  class="wow animate__animated animate__fadeInRight" >
                    <div class="div2">
                        <div class="top">
                            <p class="p1">{{item.title}}</p>
                            <img src="@/assets/price/baise11.png" alt="">
                        </div>
                        <div class="bottom">
                            <p class="p1">￥{{item.price}}/月</p>
                            <p class="p2" @click="submit(false,url+item.image)">立即购买</p>
                            <p class="p3">￥{{item.originalprice}}/年 <span>{{item.subtitle}}</span></p>
                        </div>
                    </div>
                </li>
            </ul>

            <ul v-show="price2.length>3">
                <li v-for="(item,index) in price2" :key="index"  class="wow animate__animated animate__fadeInRight">
                    <div v-if="index==0" class="div1">
                        <p class="p1">{{item.title}}</p>
                        <p class="p2">{{item.subtitle}}</p>
                        <p class="p3" @click="submit(false,url+item.image)">注册试用</p>
                    </div>
                    <div v-if="index!=0" class="div2">
                        <div class="top">
                            <p class="p1">{{item.title}}</p>
                            <img src="@/assets/price/baise11.png" alt="">
                        </div>
                        <div class="bottom">
                            <p class="p1">￥{{item.price}}/月</p>
                            <p class="p2" @click="submit(false,url+item.image)">立即购买</p>
                            <p class="p3">￥{{item.originalprice}}/年 <span>{{item.subtitle}}</span></p>
                        </div>
                    </div>
                </li>
            </ul>
            
        </div>
        <div class="price2Box">
            <ul>
                <li v-for="(item,index) in priceText.priceText1" :key="index">
                    <div class="left">
                        <p class="p1">{{item.title}}</p>
                        <p class="p2">{{item.subtitle}}</p>
                    </div>
                    <div v-for="(list1,i) in item.content" :key="i" class="right" v-html="list1" v-show="item.content.length>0"></div>
                    <div v-for="(list2,i) in item.option" :key="i" class="right"  v-show="item.option.length>0">
                        <img src="@/assets/price/true.png" alt="" v-show="list2==0">
                        <img src="@/assets/price/false.png" alt="" v-show="list2==1">
                    </div>
                </li>
            </ul>
        </div>

    </div>
    <div class="price2">
        <div class="price2top">
            <p class="title">实战课程</p>
            <ul v-show="price3.length<4">
                <li v-for="(item,index) in price3" :key="index"  class="wow animate__animated animate__fadeInRight" >
                    <div class="div2">
                        <div class="top">
                            <p class="p1">{{item.title}}</p>
                            <img src="@/assets/price/baise11.png" alt="">
                        </div>
                        <div class="bottom">
                            <p class="p1">￥{{item.price}}/月</p>
                            <p class="p2" @click="submit(false,url+item.image)">立即购买</p>
                            <p class="p3">￥{{item.originalprice}}/年 <span>{{item.subtitle}}</span></p>
                        </div>
                    </div>
                </li>
            </ul>

            <ul v-show="price2.length>3">
                <li v-for="(item,index) in price2" :key="index"  class="wow animate__animated animate__fadeInRight">
                    <div v-if="index==0" class="div1">
                        <p class="p1">{{item.title}}</p>
                        <p class="p2">{{item.subtitle}}</p>
                        <p class="p3" @click="submit(false,url+item.image)">注册试用</p>
                    </div>
                    <div v-if="index!=0" class="div2">
                        <div class="top">
                            <p class="p1">{{item.title}}</p>
                            <img src="@/assets/price/baise11.png" alt="">
                        </div>
                        <div class="bottom">
                            <p class="p1">￥{{item.price}}/月</p>
                            <p class="p2" @click="submit(false,url+item.image)">立即购买</p>
                            <p class="p3">￥{{item.originalprice}}/年 <span>{{item.subtitle}}</span></p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="price2Box">
            <ul>
                <li v-for="(item,index) in priceText.priceText2" :key="index">
                    <div class="left">
                        <p class="p1">{{item.title}}</p>
                        <p class="p2">{{item.subtitle}}</p>
                    </div>
                    <div v-for="(list1,i) in item.content" :key="i" class="right" v-html="list1" v-show="item.content.length>0"></div>
                    <div v-for="(list2,i) in item.option" :key="i" class="right"  v-show="item.option.length>0">
                        <img src="@/assets/price/true.png" alt="" v-show="list2==0">
                        <img src="@/assets/price/false.png" alt="" v-show="list2==1">
                    </div>
                </li>
            </ul>
        </div>

    </div>
    <div class="price2">
        <div class="price2top">
            <p class="title">私域店铺</p>
            <ul v-show="price4.length<4">
              <li v-for="(item,index) in price4" :key="index"  class="wow animate__animated animate__fadeInRight" >
                  <div class="div2">
                      <div class="top">
                          <p class="p1">{{item.title}}</p>
                          <img src="@/assets/price/baise11.png" alt="">
                      </div>
                      <div class="bottom">
                          <p class="p1">￥{{item.price}}/月</p>
                          <p class="p2" @click="submit(false,url+item.image)">立即购买</p>
                          <p class="p3">￥{{item.originalprice}}/年 <span>{{item.subtitle}}</span></p>
                      </div>
                  </div>
              </li>
            </ul>

            <ul v-show="price4.length>3">
                <li v-for="(item,index) in price4" :key="index"  class="wow animate__animated animate__fadeInRight">
                    <div v-if="index==0" class="div1">
                        <p class="p1">{{item.title}}</p>
                        <p class="p2">{{item.subtitle}}</p>
                        <p class="p3" @click="submit(false,url+item.image)">注册试用</p>
                    </div>
                    <div v-if="index!=0" class="div2">
                        <div class="top">
                            <p class="p1">{{item.title}}</p>
                            <img src="@/assets/price/baise11.png" alt="">
                        </div>
                        <div class="bottom">
                            <p class="p1">￥{{item.price}}/月</p>
                            <p class="p2" @click="submit(false,url+item.image)">立即购买</p>
                            <p class="p3">￥{{item.originalprice}}/年 <span>{{item.subtitle}}</span></p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="price2Box">
            <ul>
                <li v-for="(item,index) in priceText.priceText3" :key="index">
                    <div class="left">
                        <p class="p1">{{item.title}}</p>
                        <p class="p2">{{item.subtitle}}</p>
                    </div>
                    <div v-for="(list1,i) in item.content" :key="i" class="right" v-html="list1" v-show="item.content.length>0"></div>
                    <div v-for="(list2,i) in item.option" :key="i" class="right"  v-show="item.option.length>0">
                        <img src="@/assets/price/true.png" alt="" v-show="list2==0">
                        <img src="@/assets/price/false.png" alt="" v-show="list2==1">
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="price2 price3">
        <div class="price2top">
            <p class="title">企业SCRM</p>
            <ul v-show="price5.length<4">
                <li v-for="(item,index) in price5" :key="index"  class="wow animate__animated animate__fadeInRight" >
                    <div class="div2">
                        <div class="top">
                            <p class="p1">{{item.title}}</p>
                            <img src="@/assets/price/baise11.png" alt="">
                        </div>
                        <div class="bottom">
                            <p class="p1">￥{{item.price}}/月</p>
                            <p class="p2" @click="submit(false,url+item.image)">立即购买</p>
                            <p class="p3">￥{{item.originalprice}}/年 <span>{{item.subtitle}}</span></p>
                        </div>
                    </div>
                </li>
            </ul>

            <ul v-show="price5.length>3">
                <li v-for="(item,index) in price5" :key="index"  class="wow animate__animated animate__fadeInRight">
                    <div v-if="index==0" class="div1">
                        <p class="p1">{{item.title}}</p>
                        <p class="p2">{{item.subtitle}}</p>
                        <p class="p3" @click="submit(false,url+item.image)">注册试用</p>
                    </div>
                    <div v-if="index!=0" class="div2">
                        <div class="top">
                            <p class="p1">{{item.title}}</p>
                            <img src="@/assets/price/baise11.png" alt="">
                        </div>
                        <div class="bottom">
                            <p class="p1">￥{{item.price}}/月</p>
                            <p class="p2" @click="submit(false,url+item.image)">立即购买</p>
                            <p class="p3">￥{{item.originalprice}}/年 <span>{{item.subtitle}}</span></p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="price2Box">
            <ul>
                <li v-for="(item,index) in priceText.priceText4" :key="index">
                  <div class="left">
                      <p class="p1">{{item.title}}</p>
                      <p class="p2">{{item.subtitle}}</p>
                  </div>
                  <div v-for="(list1,i) in item.content" :key="i" class="right" v-html="list1" v-show="item.content.length>0"></div>
                  <div v-for="(list2,i) in item.option" :key="i" class="right"  v-show="item.option.length>0">
                      <img src="@/assets/price/true.png" alt="" v-show="list2==0">
                      <img src="@/assets/price/false.png" alt="" v-show="list2==1">
                  </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="price2">
        <div class="price2top">
            <p class="title">门店管理</p>
           <ul v-show="price6.length<4">
                <li v-for="(item,index) in price6" :key="index"  class="wow animate__animated animate__fadeInRight" >
                    <div class="div2">
                        <div class="top">
                            <p class="p1">{{item.title}}</p>
                            <img src="@/assets/price/baise11.png" alt="">
                        </div>
                        <div class="bottom">
                            <p class="p1">￥{{item.price}}/月</p>
                            <p class="p2" @click="submit(false,url+item.image)">立即购买</p>
                            <p class="p3">￥{{item.originalprice}}/年 <span>{{item.subtitle}}</span></p>
                        </div>
                    </div>
                </li>
            </ul>

            <ul v-show="price6.length>3">
                <li v-for="(item,index) in price6" :key="index"  class="wow animate__animated animate__fadeInRight">
                    <div v-if="index==0" class="div1">
                        <p class="p1">{{item.title}}</p>
                        <p class="p2">{{item.subtitle}}</p>
                        <p class="p3" @click="submit(false,url+item.image)">注册试用</p>
                    </div>
                    <div v-if="index!=0" class="div2">
                        <div class="top">
                            <p class="p1">{{item.title}}</p>
                            <img src="@/assets/price/baise11.png" alt="">
                        </div>
                        <div class="bottom">
                            <p class="p1">￥{{item.price}}/月</p>
                            <p class="p2" @click="submit(false,url+item.image)">立即购买</p>
                            <p class="p3">￥{{item.originalprice}}/年 <span>{{item.subtitle}}</span></p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="price2Box">
           <ul>
                <li v-for="(item,index) in priceText.priceText5" :key="index">
                  <div class="left">
                      <p class="p1">{{item.title}}</p>
                      <p class="p2">{{item.subtitle}}</p>
                  </div>
                  <div v-for="(list1,i) in item.content" :key="i" class="right" v-html="list1" v-show="item.content.length>0"></div>
                  <div v-for="(list2,i) in item.option" :key="i" class="right"  v-show="item.option.length>0">
                      <img src="@/assets/price/true.png" alt="" v-show="list2==0">
                      <img src="@/assets/price/false.png" alt="" v-show="list2==1">
                  </div>
                </li>
            </ul>
        </div>
    </div>
    <mydialog v-if="showtc2" @tcstatus="tcstatus" :dialogVisible1="tcshow" :imgurl="imgurl"></mydialog>
  </div>
</template>

<script>
var that
import mydialog from "@/components/dialog/dialog.vue";
import { rotationmap, price } from "@/api/api";
export default {
  components: {
    mydialog,
  },
  data() {
    return {
      showtc2: false,
      tcshow: true,
      url: window.url,
      banner: {},
      price1: [],
      price2: [],
      price3: [],
      price4: [],
      price5: [],
      price6: [],
      priceText: {
        priceText1:[],
        priceText2:[],
        priceText3:[],
        priceText4:[],
        priceText5:[],
      },
      imgurl:"",
    };
  },
  mounted() {
    //初始化动画
    that = this;
    rotationmap({ type: 3 }).then((response) => {
      that.banner = response.data.data[0];
    });
    price().then((response) => {
      that.price1 = response.data.data[0];

      that.price2 = response.data.data[1];
      that.price3 = response.data.data[2];
      that.price4 = response.data.data[3];
      that.price5 = response.data.data[4];
      that.price6 = response.data.data[5];
      for(let i=0;i<that.price2.length;i++){
        if(that.price2[i].content!=""){
          that.price2[i].content = that.price2[i].content.split(';')
        }
        that.price2[i].option = that.price2[i].option.split(';')
      }
      for(let i=0;i<that.price3.length;i++){
        if(that.price3[i].content!=""){
          that.price3[i].content = that.price3[i].content.split(';')
        }
        that.price3[i].option = that.price3[i].option.split(';')
      }
      for(let i=0;i<that.price4.length;i++){
        if(that.price4[i].content!=""){
          that.price4[i].content = that.price4[i].content.split(';')
        }
        that.price4[i].option = that.price4[i].option.split(';')
      }
      for(let i=0;i<that.price5.length;i++){
        if(that.price5[i].content!=""){
          that.price5[i].content = that.price5[i].content.split(';')
        }
        that.price5[i].option = that.price5[i].option.split(';')
      }
      for(let i=0;i<that.price6.length;i++){
        if(that.price6[i].content!=""){
          that.price6[i].content = that.price6[i].content.split(';')
        }
        that.price6[i].option = that.price6[i].option.split(';')
      }


      for(let i=0;i<response.data.data[6].length;i++){
        if(response.data.data[6][i].type==1){
          that.priceText.priceText1.push(response.data.data[6][i])
        }
        if(response.data.data[6][i].type==2){
          that.priceText.priceText2.push(response.data.data[6][i])
        }
        if(response.data.data[6][i].type==3){
          that.priceText.priceText3.push(response.data.data[6][i])
        }
        if(response.data.data[6][i].type==4){
          that.priceText.priceText4.push(response.data.data[6][i])
        }
        if(response.data.data[6][i].type==5){
          that.priceText.priceText5.push(response.data.data[6][i])
        }
      }

      for(let i=0;i<that.priceText.priceText1.length;i++){
        that.priceText.priceText1[i].content = []
        that.priceText.priceText1[i].option = []
        for(let y=0;y<that.price2.length;y++){
          if(that.price2[y].content.length>0&&i<that.price2[y].content.length){
            that.priceText.priceText1[i].content.push(that.price2[y].content[i])
          }
          if(that.price2[y].option.length>0&&i>=that.price2[y].content.length){
            that.priceText.priceText1[i].option.push(that.price2[y].option[i-that.price2[y].content.length])
          }
        }
      }

      for(let i=0;i<that.priceText.priceText2.length;i++){
        that.priceText.priceText2[i].content = []
        that.priceText.priceText2[i].option = []
        for(let y=0;y<that.price3.length;y++){
          if(that.price3[y].content.length>0&&i<that.price3[y].content.length){
            that.priceText.priceText2[i].content.push(that.price3[y].content[i])
          }
          if(that.price3[y].option.length>0&&i>=that.price3[y].content.length){
            that.priceText.priceText2[i].option.push(that.price3[y].option[i-that.price3[y].content.length])
          }
        }
      }
      for(let i=0;i<that.priceText.priceText3.length;i++){
        that.priceText.priceText3[i].content = []
        that.priceText.priceText3[i].option = []
        for(let y=0;y<that.price4.length;y++){
          if(that.price4[y].content.length>0&&i<that.price4[y].content.length){
            that.priceText.priceText3[i].content.push(that.price4[y].content[i])
          }
          if(that.price4[y].option.length>0&&i>=that.price4[y].content.length){
            that.priceText.priceText3[i].option.push(that.price4[y].option[i-that.price4[y].content.length])
          }
        }
      }

      for(let i=0;i<that.priceText.priceText4.length;i++){
        that.priceText.priceText4[i].content = []
        that.priceText.priceText4[i].option = []
        for(let y=0;y<that.price5.length;y++){
          if(that.price5[y].content.length>0&&i<that.price5[y].content.length){
            that.priceText.priceText4[i].content.push(that.price5[y].content[i])
          }
          if(that.price5[y].option.length>0&&i>=that.price5[y].content.length){
            that.priceText.priceText4[i].option.push(that.price5[y].option[i-that.price5[y].content.length])
          }
        }
      }

      for(let i=0;i<that.priceText.priceText5.length;i++){
        that.priceText.priceText5[i].content = []
        that.priceText.priceText5[i].option = []
        for(let y=0;y<that.price6.length;y++){
          if(that.price6[y].content.length>0&&i<that.price6[y].content.length){
            console.log(i,that.price6[y].content)
            that.priceText.priceText5[i].content.push(that.price6[y].content[i])
          }
          if(that.price6[y].option.length>0&&i>=that.price6[y].content.length){
            
            that.priceText.priceText5[i].option.push(that.price6[y].option[i-that.price6[y].content.length])
          }
        }
      }


      that.$nextTick(() => {
        that.$wow.init();
      });
    });
  },
  methods: {
    tcstatus(e) {
      that.showtc2 = e;
    },
    submit(e,y) {
      that.showtc2 = true;
      that.tcshow = e;
      that.imgurl= y
    },
    jumpbannerpage(e){
      if(e != that.$route.path) {
          that.$router.push(e)
      }
    }
  },
};
</script>

<style lang="less">
:root {
  --web-title-fontsize: 30px;
  --web-subtitle-fontsize: 22px;
  --web-text-fontsize: 16px;
}
#price{
  .p2,.p3{
    cursor: pointer;
  }
}
@media (min-width: 750px) {
  #price {
    .price1 {
      position: relative;
      img {
        width: 100%;
      }
      .price1Box {
        position: absolute;
        width: 1400px;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        display: flex;
        justify-content: space-between;
        img {
          width: 80px;
        }
        .price1Boxlist:nth-child(1) {
          .top {
            background: linear-gradient(314deg, #d6d6d6 0%, #a5a5a5 100%);
          }
          .li3 {
            button {
              background: linear-gradient(314deg, #d6d6d6 0%, #a5a5a5 100%);
            }
          }
        }
        .price1Boxlist:nth-child(2) {
          .top {
            background: linear-gradient(314deg, #facc4b 0%, #ff9225 100%);
          }
          .li3 {
            button {
              background: linear-gradient(314deg, #facc4b 0%, #ff9225 100%);
            }
          }
        }
        .price1Boxlist:nth-child(3) {
          .top {
            background: linear-gradient(314deg, #fe2d2d 0%, #ffd889 100%);
            position: relative;
            padding: 22px 32px 22px 100px;
            .tip {
              position: absolute;
              top: 0px;
              left: 0px;
              width: 80px;
            }
          }
          .li3 {
            button {
              background: linear-gradient(314deg, #fe2d2d 0%, #ffd889 100%);
            }
          }
        }
        .price1Boxlist {
          border-radius: 20px 20px 20px 20px;
          overflow: hidden;
          padding-bottom: 20px;
          background: rgba(255, 255, 255, 0.4);
          .top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 22px 22px;
            .p1 {
              font-size: var(--web-title-fontsize);
              font-weight: bold;
              color: #fefefe;
              letter-spacing: 2px;
              border-bottom: 1px solid #fff;
              padding-bottom: 25px;
            }
          }
          .bottom {
            background: #ffffff;
            border-radius: 0px 0px 20px 20px;
            margin: 0 20px;
            padding: 16px 20px 16px 22px;
            .p2 {
              font-size: var(--web-subtitle-fontsize);
              font-weight: 300;
              color: #353535;
              margin-bottom: 16px;
            }
            ul {
              display: flex;
              align-items: flex-end;
              .li1 {
                font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                font-weight: bold;
                color: #ea2d2d;
                margin-right: 18px;
                span {
                  font-size: var(--web-title-fontsize);
                }
              }
              .li2 {
                font-size: var(--web-suvtitle-fontsize);
                font-weight: 300;
                color: #8a8a8a;
                margin-right: 60px;
                text-decoration: line-through;
              }
              .li3 {
                button {
                  border-radius: 39px 39px 39px 39px;
                  padding: 10px 20px;
                  font-size: var(--web-text-fontsize);
                  font-weight: bold;
                  color: #fefefe;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
    .price2 {
      width: 1400px;
      margin: 70px auto 40px;
      .price2top {
        display: flex;
        // justify-content: space-between;
        align-items: flex-start;
        .title {
          font-size: var(--web-title-fontsize);
          font-weight: bold;
          color: #353535;
          position: relative;
          padding-left: 40px;
          margin-right: 240px;
        }
        .title::after {
          content: "";
          display: block;
          width: 15px;
          height: 30px;
          background: #216edc;
          border-radius: 20px 20px 20px 20px;
          position: absolute;
          left: 0;
          top: 8px;
        }
        ul {
          display: flex;
          img {
            width: 44px;
            margin-left: 20px;
          }
          li {
            margin-left: 60px;
          }
          .div1 {
            background: #f3f8ff;
            box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
            border-radius: 24px 24px 24px 24px;
            padding: 27px;
            text-align: center;
            .p1 {
              font-size: 28px;
              font-weight: bold;
              color: #216edc;
              margin-bottom: 40px;
            }
            .p2 {
              font-size: 18px;
              font-weight: 400;
              color: #226fdd;
              margin-bottom: 40px;
            }
            .p3 {
              background: linear-gradient(314deg, #f7c63b 0%, #ff9225 100%);
              border-radius: 34px 34px 34px 34px;
              font-size: 23px;
              font-weight: normal;
              color: #fffdfd;
              padding: 8px 20px;
            }
          }
          .div3 {
            background: #f3f8ff;
            box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
            border-radius: 24px 24px 24px 24px;
            padding: 27px;
            text-align: center;
            .p1 {
              font-size: 28px;
              font-weight: bold;
              color: #216edc;
              margin-bottom: 20px;
            }
            .p2 {
              font-size: 18px;
              font-weight: 400;
              color: #226fdd;
              margin-bottom: 30px;
            }
            .p3 {
              background: linear-gradient(314deg, #f7c63b 0%, #ff9225 100%);
              border-radius: 34px 34px 34px 34px;
              font-size: 23px;
              font-weight: normal;
              color: #fffdfd;
              padding: 8px 20px;
            }
          }
          .div2 {
            background: #f3f8ff;
            box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
            border-radius: 12px 12px 12px 12px;
            overflow: hidden;
            padding-bottom: 20px;
            // margin-left: 25px;
            .top {
              display: flex;
              font-size: 24px;
              font-weight: bold;
              color: #ffffff;
              padding: 8px 9px 8px 24px;
            }
            .bottom {
              text-align: center;
              .p1 {
                font-size: 19px;
                font-weight: bold;
                color: #4b4b4b;
                margin-bottom: 25px;
                margin-top: 20px;
              }
              .p2 {
                border-radius: 35px 35px 35px 35px;
                font-size: 21px;
                font-weight: normal;
                color: #ffffff;
                padding: 8px 20px;
                margin: 0 20px 20px;
              }
              .p3 {
                font-size: 21px;
                font-weight: normal;
                color: #313131;
                span {
                  background: linear-gradient(90deg, #f85721 0%, #f96a24 100%);
                  border-radius: 14px 14px 14px 14px;
                  color: #fff;
                  margin-left: 28px;
                  padding: 3px 10px;
                }
              }
            }
          }
          li:nth-child(2) {
            .div2 {
              .top {
                background: linear-gradient(314deg, #d6d6d6 0%, #a5a5a5 100%);
              }
              .bottom {
                .p2 {
                  background: linear-gradient(270deg, #d4d4d4 0%, #a7a7a7 100%);
                }
              }
            }
          }
          li:nth-child(3) {
            .div2 {
              .top {
                background: linear-gradient(314deg, #facc4b 0%, #ff9225 100%);
              }
              .bottom {
                .p2 {
                  background: linear-gradient(314deg, #facc4b 0%, #ff9225 100%);
                }
              }
            }
          }
          li:nth-child(4) {
            .div2 {
              .top {
                background: linear-gradient(314deg, #fe2d2d 0%, #ffd889 100%);
              }
              .bottom {
                .p2 {
                  background: linear-gradient(314deg, #fe2d2d 0%, #ffd889 100%);
                }
              }
            }
          }
        }
      }
      .price2Box {
        margin-top: 40px;
        ul {
          li:nth-child(1) {
            border-top: 1px solid #d3d3d3;
          }
          li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 0 15px 20px;
            // margin-bottom: 15px;
            border-bottom: 1px solid #d3d3d3;
            .p2 {
              width: 280px;
              font-size: var(--web-text-fontsize);
              font-weight: 400;
              color: #707070;
              margin-top: 8px;
            }
            .p1 {
              font-size: var(--web-subtitle-fontsize);
              font-weight: 500;
              color: #232323;
            }
            .left {
              width: 300px;
            }
            .right {
              width: 140px;
              text-align: center;
              font-size: var(--web-subtitle-fontsize);
              font-weight: 500;
              color: #232323;
              img {
                width: 24px;
              }
            }
          }
        }
      }
    }
    .price3 {
      ul {
        li:nth-child(1) {
          .div2 {
            .top {
              background: linear-gradient(314deg, #d6d6d6 0%, #a5a5a5 100%);
            }
            .bottom {
              .p2 {
                background: linear-gradient(270deg, #d4d4d4 0%, #a7a7a7 100%);
              }
            }
          }
        }
        li:nth-child(2) {
          .div2 {
            .top {
              background: linear-gradient(314deg, #facc4b 0%, #ff9225 100%);
            }
            .bottom {
              .p2 {
                background: linear-gradient(314deg, #facc4b 0%, #ff9225 100%);
              }
            }
          }
        }
        li:nth-child(3) {
          .div2 {
            .top {
              background: linear-gradient(314deg, #fe2d2d 0%, #ffd889 100%);
            }
            .bottom {
              .p2 {
                background: linear-gradient(314deg, #fe2d2d 0%, #ffd889 100%);
              }
            }
          }
        }
      }
      .price2top {
        ul {
          li {
            margin-left: 80px;
          }
          li:nth-child(-n+2){
            margin-right: 80px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  #price {
    .price1 {
      position: relative;
      img {
        width: 100%;
      }
      .price1Box {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        img {
          width: 20px;
        }
        .price1Boxlist:nth-child(1) {
          background: linear-gradient(314deg, #d6d6d6 0%, #a5a5a5 100%);
          .li3 {
            button {
              background: linear-gradient(314deg, #d6d6d6 0%, #a5a5a5 100%);
            }
          }
        }
        .price1Boxlist:nth-child(2) {
          background: linear-gradient(314deg, #facc4b 0%, #ff9225 100%);
          .li3 {
            button {
              background: linear-gradient(314deg, #facc4b 0%, #ff9225 100%);
            }
          }
        }
        .price1Boxlist:nth-child(3) {
          background: linear-gradient(314deg, #fe2d2d 0%, #ffd889 100%);
          .top {
            position: relative;
            padding: 10px 10px 10px 30px;
            .tip {
              position: absolute;
              top: 0px;
              left: 0px;
              width: 30px;
            }
          }
          .li3 {
            button {
              background: linear-gradient(314deg, #fe2d2d 0%, #ffd889 100%);
            }
          }
        }
        .price1Boxlist {
          flex: 0 0 90%;
          border-radius: 10px;
          overflow: hidden;
          padding-bottom: 10px;
          background: rgba(255, 255, 255, 0.4);
          margin-bottom: 20px;
          .top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 10px;
            .p1 {
              font-size: 12px;
              font-weight: bold;
              color: #fefefe;
              letter-spacing: 2px;
              border-bottom: 1px solid #fff;
              padding-bottom: 5px;
            }
          }
          .bottom {
            background: #ffffff;
            border-radius: 0px 0px 10px 10px;
            margin: 0 10px;
            padding: 10px;
            .p2 {
              font-size: 10px;
              font-weight: 300;
              color: #353535;
              margin-bottom: 5px;
            }
            ul {
              display: flex;
              align-items: flex-end;
              .li1 {
                font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                font-weight: bold;
                color: #ea2d2d;
                margin-right: 18px;
                span {
                  font-size: 16px;
                }
              }
              .li2 {
                font-size: 12px;
                font-weight: 300;
                color: #8a8a8a;
                margin-right: 60px;
                text-decoration: line-through;
              }
              .li3 {
                button {
                  border-radius: 39px 39px 39px 39px;
                  padding: 10px 20px;
                  font-size: 12px;
                  font-weight: bold;
                  color: #fefefe;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
    .price2 {
      width: 100%;
      margin: 70px auto 40px;
      .price2top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        .title {
          flex: 0 0 100%;
          font-size: 24px;
          font-weight: bold;
          color: #353535;
          position: relative;
          padding-left: 40px;
          margin-bottom: 20px;
          margin-right: 10px;
        }
        .title::after {
          content: "";
          display: block;
          width: 10px;
          height: 21px;
          background: #216edc;
          border-radius: 20px 20px 20px 20px;
          position: absolute;
          left: 19px;
          top: 7px;
        }
        ul {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          li {
            flex: 0 0 90%;
            margin-bottom: 20px;
          }
          img {
            width: 44px;
            margin-left: 30px;
          }
          .div1 {
            background: #f3f8ff;
            box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
            border-radius: 24px 24px 24px 24px;
            padding: 27px;
            text-align: center;
            .p1 {
              font-size: 28px;
              font-weight: bold;
              color: #216edc;
              margin-bottom: 40px;
            }
            .p2 {
              font-size: 18px;
              font-weight: 400;
              color: #226fdd;
              margin-bottom: 40px;
            }
            .p3 {
              background: linear-gradient(314deg, #f7c63b 0%, #ff9225 100%);
              border-radius: 34px 34px 34px 34px;
              font-size: 23px;
              font-weight: normal;
              color: #fffdfd;
              padding: 8px 20px;
            }
          }
          .div3 {
            background: #f3f8ff;
            box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
            border-radius: 24px 24px 24px 24px;
            padding: 27px;
            text-align: center;
            .p1 {
              font-size: 28px;
              font-weight: bold;
              color: #216edc;
              margin-bottom: 20px;
            }
            .p2 {
              font-size: 18px;
              font-weight: 400;
              color: #226fdd;
              margin-bottom: 30px;
            }
            .p3 {
              background: linear-gradient(314deg, #f7c63b 0%, #ff9225 100%);
              border-radius: 34px 34px 34px 34px;
              font-size: 23px;
              font-weight: normal;
              color: #fffdfd;
              padding: 8px 20px;
            }
          }
          .div2 {
            background: #f3f8ff;
            box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
            border-radius: 12px 12px 12px 12px;
            overflow: hidden;
            padding-bottom: 20px;
            .top {
              display: flex;
              font-size: 24px;
              font-weight: bold;
              color: #ffffff;
              padding: 8px 9px 8px 34px;
            }
            .bottom {
              text-align: center;
              .p1 {
                font-size: 19px;
                font-weight: bold;
                color: #4b4b4b;
                margin-bottom: 25px;
                margin-top: 20px;
              }
              .p2 {
                border-radius: 35px 35px 35px 35px;
                font-size: 21px;
                font-weight: normal;
                color: #ffffff;
                padding: 8px 20px;
                margin: 0 20px 20px;
              }
              .p3 {
                font-size: 21px;
                font-weight: normal;
                color: #313131;
                span {
                  background: linear-gradient(90deg, #f85721 0%, #f96a24 100%);
                  border-radius: 14px 14px 14px 14px;
                  color: #fff;
                  margin-left: 28px;
                  padding: 3px 10px;
                }
              }
            }
          }
          li:nth-child(2) {
            .div2 {
              .top {
                background: linear-gradient(314deg, #d6d6d6 0%, #a5a5a5 100%);
              }
              .bottom {
                .p2 {
                  background: linear-gradient(270deg, #d4d4d4 0%, #a7a7a7 100%);
                }
              }
            }
          }
          li:nth-child(3) {
            .div2 {
              .top {
                background: linear-gradient(314deg, #facc4b 0%, #ff9225 100%);
              }
              .bottom {
                .p2 {
                  background: linear-gradient(314deg, #facc4b 0%, #ff9225 100%);
                }
              }
            }
          }
          li:nth-child(4) {
            .div2 {
              .top {
                background: linear-gradient(314deg, #fe2d2d 0%, #ffd889 100%);
              }
              .bottom {
                .p2 {
                  background: linear-gradient(314deg, #fe2d2d 0%, #ffd889 100%);
                }
              }
            }
          }
        }
      }
      .price2Box {
        margin-top: 40px;
        ul {
          li:nth-child(1) {
            border-top: 1px solid #d3d3d3;
          }
          li {
            margin: 0 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 0 15px 0px;
            // margin-bottom: 15px;
            border-bottom: 1px solid #d3d3d3;
            .p2 {
              width: 280px;
              font-size: 20px;
              font-weight: 400;
              color: #707070;
              margin-top: 8px;
              display: none;
            }
            .p1 {
              font-size: 12px;
              font-weight: 500;
              color: #232323;
            }
            .left {
              width: 60px;
              overflow: hidden; //超出隐藏
              white-space: nowrap; //不折行
              text-overflow: ellipsis; //溢出显示省略号
            }
            .right {
              text-align: center;
              font-size: 12px;
              font-weight: 500;
              color: #232323;
              img {
                width: 12px;
              }
            }
          }
        }
      }
    }
    .price3 {
      ul {
        li:nth-child(1) {
          .div2 {
            .top {
              background: linear-gradient(314deg, #d6d6d6 0%, #a5a5a5 100%);
            }
            .bottom {
              .p2 {
                background: linear-gradient(270deg, #d4d4d4 0%, #a7a7a7 100%);
              }
            }
          }
        }
        li:nth-child(2) {
          .div2 {
            .top {
              background: linear-gradient(314deg, #facc4b 0%, #ff9225 100%);
            }
            .bottom {
              .p2 {
                background: linear-gradient(314deg, #facc4b 0%, #ff9225 100%);
              }
            }
          }
        }
        li:nth-child(3) {
          .div2 {
            .top {
              background: linear-gradient(314deg, #fe2d2d 0%, #ffd889 100%);
            }
            .bottom {
              .p2 {
                background: linear-gradient(314deg, #fe2d2d 0%, #ffd889 100%);
              }
            }
          }
        }
      }
    }
  }
}
</style>